module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('CreateTaskForm', {
    attrs: {
      "user": _vm.user,
      "date": _vm.date,
      "initSubject": _vm.initSubject,
      "theNewlyCreatedSubject": _vm.theNewlyCreatedSubject,
      "editEvent": _vm.editEvent,
      "openingHours": _vm.openingHours
    },
    on: {
      "setDate": _vm.setDate,
      "close": function($event) {
        return _vm.$emit('close')
      },
      "createNewSubject": function($event) {
        return _vm.setCreateNewSubject($event)
      },
      "onCreatedEvent": _vm.onCreatedEvent,
      "deleteEvent": _vm.onDeleteEvent,
      "updatedEvent": function($event) {
        return _vm.$emit('updatedEvent', $event)
      }
    }
  }), _vm._v(" "), (_vm.theCreateNewSubjectName) ? _c('CreateTaskNewSubject', {
    attrs: {
      "user": _vm.user,
      "date": _vm.date,
      "title": _vm.theCreateNewSubjectName
    },
    on: {
      "newSubject": _vm.onNewSubject,
      "close": function($event) {
        return _vm.setCreateNewSubject(null)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.theDeleteEvent) ? _c('ModalConfirmation', {
    attrs: {
      "isSubmitButtonLoading": _vm.isDeleting
    },
    on: {
      "confirm": _vm.deleteEvent,
      "close": _vm.onCloseConfirmation
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-c66684fc!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/DutySchedule/CreateEvent/CreateEvent.vue
// module id = 2121
// module chunks = 1